import React from 'react'
import { Tab } from '../../types/windows'
import './TabBar.css'

interface TabBarProps {
  tabs: Tab[]
  activeTabId: string
  onTabClick: (tabId: string) => void
  onTabClose: (tabId: string) => void
}

export const TabBar: React.FC<TabBarProps> = ({
  tabs,
  onTabClick,
  onTabClose,
}) => {
  return (
    <div className="tab-bar">
      <div className="tab-list">
        {tabs.map(tab => (
          <div
            key={tab.id}
            className={`tab ${tab.active ? 'active' : ''} ${!tab.closable ? 'non-closable' : ''}`}
            onClick={() => onTabClick(tab.id)}
          >
            <span className="tab-title">{tab.title}</span>
            {tab.closable && (
              <button
                className="tab-close-btn"
                onClick={(e) => {
                  e.stopPropagation()
                  onTabClose(tab.id)
                }}
                aria-label={`Close ${tab.title}`}
              >
                ×
              </button>
            )}
          </div>
        ))}

      </div>
    </div>
  )
}
